import { dataFetcher } from 'core/services/requestHandler';   

const getBookingReport = async (data = {}, config = {}) => {
  return dataFetcher('reports/bookings', data, {...config});
};

const getIncentiveReport = async (data = {}, config = {}) => {
  return dataFetcher('reports/incentives', data, {...config});
};

const getPayoutReport = async (data = {}, config = {}) => {
  return dataFetcher('reports/payouts', data, {...config});
};
const getEnquiryReport = async (data = {}, config = {}) => {
  return dataFetcher('reports/enquiries', data, {...config});
};


export { getBookingReport, getIncentiveReport, getPayoutReport, getEnquiryReport };
